import { Trans } from 'react-i18next';
import { Flex } from 'ui';
import { Text } from 'ui/typography';

type P = {
  expectedOutcomes: string[];
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramExpectedOutcomes = ({ expectedOutcomes }: P) => (
  <Flex className="card-wrapper card-wrapper--expected-outcomes">
    <Flex className="card-content" vertical>
      <Text className="card-content__title">
        <Trans>Expected outcomes</Trans>
      </Text>
      <ul className="outcomes-list">
        {expectedOutcomes.map((outcome, index) => (
          // eslint-disable-next-line react/no-array-index-key -- Outcomes have no identifier and are not unique
          <li key={index}>{outcome}</li>
        ))}
      </ul>
    </Flex>
  </Flex>
);

export default ProgramExpectedOutcomes;
